var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-col" }, [
    _c("div", { staticClass: "text-14-black33-b margin-top-16" }, [
      _vm._v(_vm._s(_vm.label)),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex margin-top-16 flex-row-center-jx  padding-h-16 height-32 border-eb-1 just-end",
      },
      [
        _vm.distinctions && _vm.distinctions.length > 0
          ? _c(
              "el-dropdown",
              {
                on: {
                  command: function ($event) {
                    _vm.handleCommand($event, _vm.child)
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "el-dropdown-link text-14-orangeFF margin-left-16",
                  },
                  [
                    _vm._v(
                      "\n                        添加财产类型\n                      "
                    ),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right",
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  _vm._l(_vm.distinctions, function (item, index) {
                    return _c(
                      "el-dropdown-item",
                      { key: index, attrs: { command: item } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.label) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.children.length > 0
      ? _c(
          "div",
          _vm._l(_vm.children, function (item, count) {
            return _c("div", { key: count }, [
              _c(
                "div",
                { staticClass: "propertyPiece" },
                [
                  _vm._l(item, function (group, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c(_vm.groupView, {
                          tag: "div",
                          attrs: { "group-data": group },
                          on: {
                            groupChildrenChange: function ($event) {
                              _vm.groupDataChange(group, $event)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-error delPiece",
                    on: {
                      click: function ($event) {
                        _vm.getDelProperty(item)
                      },
                    },
                  }),
                ],
                2
              ),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }